<i18n lang='yml' src='../i18n/ContainerForm.yml'></i18n>
<template>
  <div class="row">
    <div class="col-sm-12">
      <flash :message_type="message_type" :message_text="message_text"/>
      <Form class="edit-container" ref="observer" v-slot="{  errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
          <fieldset class="border-bottom">
            <div v-if="containerType.options_store">
              <div class='form-group row'>
                <div class='col-md-12'>
                  <Field 
                    :name="$t('name.label', { type: containerType[`name_en`]} )" 
                    rules="required" 
                    v-slot="{ field, errors, ariaMsg }"
                    v-model="containerData.name">
                    <label for="name">  {{ $t('name.label', { type: containerType[`name_en`]} ) }} </label>
                    <span class="red">*<span class="sr-only">{{$t('required')}}</span></span>
                    <input id="name" 
                      name="name"
                      class="form-control" 
                      :class="{'is-invalid': errors[0]}" 
                      v-bind="field"
                      aria-describedby="errors[0] ? 'name_en_error' : 'name'"
                      type="text">
                    <div class="invalid-feedback" id="name_en_error" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span v-bind="ariaMsg"> {{ errors[0] }}</span>
                    </div>
                  </Field>  
                </div>
              </div>
              <div class='form-group row'>
                <div class='col-md-12' v-for="language in containerType.options_store.additional_languages" :key="language">
                  <Field 
                    :name="$t('name_other.label', { type: containerType[`name_${locale}`], language: $t(language) })" 
                    rules="required" 
                    v-slot="{ field, errors, ariaMsg }"
                    v-model="containerData.additional_language_names[language]">
                    <label :for="`name_other_${language}`">{{ $t('name_other.label', { type: containerType[`name_${locale}`], language: $t(language) }) }}</label>
                    <span class="red">*<span class="sr-only">{{$t('required')}}</span></span>
                    <input :id="`name_other_${language}`"
                      :name="`name_other_${language}`"
                      class="form-control" 
                      v-bind="field"
                      :class="{'is-invalid': errors[0]}"
                      type="text">
                    <div class="invalid-feedback" :id="`name_other_${language}_error`" v-if="errors[0]">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                      <span v-bind="ariaMsg">{{ errors[0] }}</span>
                    </div>
                  </Field>  
                </div>
              </div>
            </div>
            <div class="form-group row" v-if="containerType.options_store && !containerType.options_store.hide_description">
              <div class="col-sm-12">
                <froala-editor-vue 
                  htmlfor = "description"
                  id="description" 
                  @setText="setText" 
                  :title="$t('description.label')"
                  :text="containerData.description"/>
                <p class="help-block clearfix">
                  <font-awesome-icon icon="fa-solid fa-info-circle"  class='blue' />
                  {{ $t('description.info') }}
                </p>
              </div>
            </div>            
            <template v-if="containerType.options_store && !containerType.options_store.hide_scorm_package">
              <hr/>
              <div class="form-group row">
                <div class="col-sm-12 col-md-8">
                  <label>  {{ $t('scorm_package.label') }} </label>
                  <p v-if="containerData.certificate_id"> {{$t('scorm_package.guiding_text')}} </p>
                  <select id="scorm_package_id" name="scorm_package_id" class="form-control" v-model="containerData.scorm_package_id">
                    <option v-for="option in scormPackageOptions" :value="option.id" :key="option.id">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12 col-md-8">
                  <label>  {{ $t('certificate.label') }} </label>
                  <p v-if="containerData.scorm_package_id"> {{$t('certificate.guiding_text')}} </p>
                  <select id="certificate_id" name="certificate_id" class="form-control" v-model="containerData.certificate_id">
                    <option v-for="option in certificateOptions" :value="option.id" :key="option.id">
                      {{ option.title[locale] }}
                    </option>
                  </select>
                </div>
              </div>
              <template v-if="type === 'edit'">

                <div class='form-group row'>
                  <div class='col-sm-12 col-md-8'>
                    <label for="scorm_completion_title"> {{ $t('scorm_completion_title') }}  </label>
                    <input id="scorm_completion_title" name="scorm_completion_title" type="text"  class="form-control"  v-model="containerData.metadata.scorm_completion_title">
                  </div>        
                </div>

                <div class='form-group row'>
                  <div class='col-sm-12 col-md-8'>
                    <label for="scorm_certification_survey">  {{ $t('scorm_certification_survey') }} </label>
                    <input id="scorm_certification_survey" name="scorm_certification_survey" type="text"  class="form-control"  v-model="containerData.metadata.scorm_certification_survey">
                  </div>        
                </div>

                <div class="form-group row">
                  <div class="col-sm-12">
                    <froala-editor-vue 
                      htmlfor = "scorm_completion_content"
                      id="scorm_completion_content" 
                      @setText="setText" 
                      :title="$t('scorm_completion_content')"
                      :text="containerData.metadata.scorm_completion_content"/>
                  </div>
                </div>
              </template>
            </template>
        </fieldset>
            <submit-questions-vue :locale="locale" :s_questions="metadata_questions" :s_reponses="metadataAnswers" @setResponses="setResponses" :errors="errors" />
          <fieldset>
            <div class='form-group row' v-if="containerType.options_store && !containerType.options_store.hide_woo_commerce">
              <div class='col-sm-12 col-md-8'>
                <label>  {{ $t('woo_commerce.id') }} </label>
                <input id="woo_commerce_identifier" name="woo_commerce_identifier" type="text"  class="form-control" v-model="containerData.metadata.woo_commerce_identifier">              </div>
            </div>       
          </fieldset>

          <div class="select-slide in-profile border-bottom" v-if="classificationData.length > 0" >
            <label class="status-bold">
              {{ $t('classifications') }}
            </label>
            <fieldset>
              <div :key="classification.id" v-for=" (classification,index) in classificationData" >
                <div class="form-group row">
                  <div class="col-md-12 col-lg-9">
                    <div class="mb-2"> {{ classification.name }} </div>
                    <multi-select
                        v-model="selectedClassification[index].selected"
                        :options="getOptions(classification.dropdown_classifications)"
                        mode="tags"
                        :close-on-select="false"
                        :hideSelected="false"
                        v-bind="field" 
                        :searchable="true"
                        :create-option="false"
                        :canClear="true"
                        :class="{'is-invalid': errors[0]}" 
                        track-by="value"
                        label="label"
                        key="value"
                      />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <fieldset class="border-bottom" v-if="containerType.options_store && !containerType.options_store.hide_access_levels">
            <label class="status-bold">
               {{ $t('access_level') }}        
            </label>
            <div class='form-group row select-group'>
              <div class='col-md-12'>
                <div class="radio-inline" v-for="(key, val ,index) in accessLevels" :key="index">
                  <label >
                    <input type="radio" :id="val" :name="val" v-model="containerData.access_level" :value="val" > 
                      {{ $t(`container_access_level.${val}`) }}
                  </label>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="border-bottom" v-if="containerType.options_store && !containerType.options_store.hide_moderation">
            <label class="status-bold"> {{ $t('moderation') }} </label>
            <p>{{$t('post_moderation.header')}}</p>
            <div class='form-group row select-group'>
              <div class='col-md-12'>
                <div class="radio-inline" >
                  <label >
                    <input type="radio" id="container_post_moderation_true" v-model="containerData.metadata.post_moderation" value="true">
                    {{ $t("post_moderation.moderated") }}
                  </label>
                </div>
                <div class="radio-inline" >
                  <label >
                    <input type="radio" id="container_post_moderation_false" v-model="containerData.metadata.post_moderation" value="false">{{ $t("post_moderation.unmoderated") }}
                  </label>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="border-bottom" v-if="containerType.options_store && !containerType.options_store.hide_membership_code">
            <div class="mb-2">
              <label class="status-bold"> {{ $t('membership_code.header') }} </label>
              <p>{{$t('membership_code.description')}}</p>
              <div class='form-group row select-group'>
                <div class='col-md-12'>
                  <label>
                    <input  type="checkbox" id="membership_code_required" aria-labelledby="membership_code_required" v-model="containerData.metadata.membership_code_required">
                  {{$t('membership_code.required')}}</label>
        
                </div>
              </div>
            </div>
            <div class="mb-2" v-if="type == 'edit'">
              <hr/>
              <label> {{ $t('no_membership_code_help_text.header') }} </label>
              <p>{{$t('no_membership_code_help_text.description')}}</p>

              
              <div class="form-group row ">
                  <div class="col-sm-12">
                    <froala-editor-vue 
                      htmlfor = "no_membership_code_help_text"
                      id="no_membership_code_help_text" 
                      @setText="setText" 
                      title=""
                      :text="containerData.metadata.no_membership_code_help_text"/>
                  </div>
                </div>
            </div>
          </fieldset> 
          <template v-if="type === 'edit' && redirect_path && hide_membership_limitations !== 'true'">
            <div class='row'>
              <div class='col-md-8'>
                <container-management-vue :roles="roles" :limits='limits' :counts="counts"/>
              </div>
            </div>
          </template>
          
          <fieldset class="border-bottom" v-if="containerType.options_store && !containerType.options_store.hide_optional_url">
            <legend> {{ $t('url_name.header', { type: containerType[`name_${locale}`]})}} </legend>
            <div class='form-group row'>
              <div class='col-md-12'>
                <label>  {{ $t('url_name.label') }} </label>
                <input id="url_name" name="url_name" type="text" class="form-control" v-model="containerData.url_name">    
              </div>
            </div>
          </fieldset> 
          <template v-if="type != 'edit'">
            <fieldset class="border-bottom" v-if="containerType.options_store && !containerType.options_store.hide_container_import">
              <legend> {{ $t('import_container.header')}} </legend>
              <container-import-vue  @selected="handleImportContainerId" locale="I18n.locale" :networks="networks" :endpoint="import_url" />
            </fieldset>
          </template>

           <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
            <span class="red mr-2">
              <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
            </span>
            {{ $t('error_warning') }}
          </div>
          <div class="btn-row d-flex">
            <button type="submit" class="btn btn-primary btn-success no-shadow">
              <font-awesome-icon :icon="['fa', 'save']" />
              {{$t('submit.save', { pageType: type == 'edit' ? $t('update') : $t('create') })}}
            </button>

            <a v-if="type == 'edit'  && containerType.options_store && !containerType.options_store.hide_container_delete" 
              class="btn btn-danger" 
              :data-confirm="$t('delete_prompt', 
              {model: containerType[`name_${locale}`]})" 
              data-method="delete" :href="`${base_path}/${containerData.id}`"
            >
              <font-awesome-icon :icon="['fa', 'trash-alt']" />
              {{ $t('submit.delete_container', {model: containerType[`name_${locale}`]}) }}
            </a>

            <a class="btn btn-light ml-auto" :href="base_path">
                <font-awesome-icon :icon="['fa', 'times']" />
                {{ $t('submit.cancel')}}
            </a>
            
          </div>
      </Form>
    </div>
  </div>
</template>

<script>

import VueFroalaEditor from '../../../../shared/FroalaEditor/FroalaEditor.vue';
import SubmitQuestions from '../../../../shared/containers/components/SubmitQuestions.vue';
import containerImport from './Import.vue'
import { Form, Field } from 'vee-validate'
import flash from '../../../../shared/flash_messages/components/Flash.vue'
import '../../../../../javascripts/application/vee-validate-rules.js'
import ContainerManagementVue from '../../../../containers/admin/components/ContainerManagement.vue';
import { sendAjaxRequest } from '../../../../shared/typescripts/ajax.ts'
import { setErrorMessage } from '../../../../shared/typescripts/error.ts'

export default {
  components: { VueFroalaEditor, SubmitQuestions, containerImport, flash, Form, Field, ContainerManagementVue},
  props: [ 'locale', 'type', 'container', 'container_type', 'scorm_package_info', 'metadata_questions', 'metadata_answers', 'access_levels',
          'current_networks', 'import_url', 'base_path', 'classifications', 'classifications_selected', 'certificate_info', 'redirect_path',
          'roles', 'limits', 'counts', 'hide_membership_limitations'],
  data() {
    return {
      containerData: {
        id: "",
        name: '',
        description: null,
        user_id: "", 
        container_type_id: "", 
        url_name: null,
        scorm_package_id: null,
        certificate_id: null,
        access_level: "",
        system_classification_ids: [],
        additional_language_names: {},
        metadata: {
          woo_commerce_identifier: null,
          membership_code_required: false,
          scorm_completion_title: "",
          scorm_completion_survey: "",
          post_moderation: null
        },
      },
      message_text: [],
      message_type: "",
      classificationData: [],
      metadataQuestions: [],
      metadataAnswers: [],
      scormPackageOptions: {},
      certificateOptions: {},
      accessLevels: [],
      containerType: {},
      selectedClassifications: [],
      areRequired: [],
      importContainerId: null,
      selectedClassification: [], 
      showErrorBanner: false,
      networks:  [],
    };
  },

  methods: {
    getOptions(data,) {
      
      let newArray = [];
      data.map((item) => {
        newArray.push({value: item.id, label: item.label})
      })
      return newArray
    },
    handleImportContainerId(id) {
      this.importContainerId = id;
    },

    async submitUserInput(e) {
      this.containerData.system_classification_ids = this.selectedClassification.flatMap(element => element.selected.map(selection => selection.id)); 
      let data = {container: this.containerData, import_container_id: this.importContainerId,  survey_responses: {responses: this.metadataAnswers}} 
      let send_type = this.type == 'edit' ? 'PUT' : 'POST'
      let path = this.type == 'edit' ? `${this.base_path}/${this.containerData.id}` : this.base_path

      sendAjaxRequest(send_type, path, 'json', data, this.ajaxSuccess, this.throwError)
    },

    ajaxSuccess(response) {
      if(response.error){
        this.message_type = "error";
        this.message_text.push(response.error)
      }
      else {
        if (this.redirect_path) {
            window.location.replace(this.redirect_path)
        } else {
          window.location.replace(response.path);    
        }
                    
      }
    },

    throwError() {
      console.log("Error")
    },

    setText(obj) {
      this.containerData[obj.id] = obj.text
    },

    setResponses(responses) {
      this.metadataAnswers = responses
    },

    inititalizeSelectedClassificationArray(){
      this.selectedClassification = this.classificationData.map(classification => {
        return { selected: [] };
      })
      this.classificationData.forEach((classification, index) => {
        const selectedOptions = classification.dropdown_classifications.filter(option => {
          return this.selectedClassifications.some(sctObj => sctObj.id === option.id );
        });
        this.selectedClassification[index].selected = selectedOptions;
      });
    },

    setErrorMessage({ valuese, errors, results }) {
      setErrorMessage(this, errors, true)
    },
  },

  mounted() {   
      this.$i18n.locale = this.locale;

      try {
        this.containerData = JSON.parse(this.container);
        this.containerData.metadata.membership_code_required = this.containerData.metadata.membership_code_required == "1"
        this.selectedClassifications = JSON.parse(this.classifications_selected)
        this.containerData.additional_language_names ||= {}
        this.scormPackageOptions = this.scorm_package_info ? JSON.parse(this.scorm_package_info) : null
        this.certificateOptions = this.certificate_info ? JSON.parse(this.certificate_info) : null
        this.metadataAnswers = this.metadata_answers ? JSON.parse(this.metadata_answers) : []
        this.accessLevels = JSON.parse(this.access_levels)
        this.containerType = JSON.parse(this.container_type)
        this.classificationData = JSON.parse(this.classifications)
        this.networks = JSON.parse(this.current_networks)
      }
      catch(err) {
        this.error = true;
        console.log(err)
      }
      
      this.inititalizeSelectedClassificationArray()
  },
  created() {
    // Since submit-question mount runs before container-form mount we have to 
    // extract metadata_answers prop here to make it available for submit-form mount
    this.metadataAnswers = this.metadata_answers ? JSON.parse(this.metadata_answers) : []
  }
};
</script>
